import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { LoginService } from '../../../services/login/login.service';


@Component({
  selector: 'app-recordatorio-pwd',
  templateUrl: './recordatorio-pwd.component.html',
  styleUrls: ['./recordatorio-pwd.component.scss'],
  standalone: false,
  providers: [MessageService]
})

export class RecordatorioPwdComponent implements OnInit {
  isLoad: boolean = false;
  form = new FormGroup({
    login: new FormControl('', [Validators.required, Validators.minLength(7), Validators.maxLength(100)])
  })
  
  constructor(private message: MessageService, private login: LoginService,) {
  }

  ngOnInit(): void {
  }

  

  continuar() {
    if (this.form.controls.login.valid) {
      this.isLoad = true;
      const data = { "Email": this.form.controls.login.value }
      this.login.rememberPwd(data).subscribe({
        next: (reponse) => {
          this.message.add({ key: 'message', severity: 'success', summary: 'Información Correcta', detail: 'Fue enviada la información a su bandeja de correo ' + data.Email });
          this.form.controls.login.setValue("");
          this.isLoad = false;
        }, error: (error: Response) => {
          this.message.add({ key: 'message', severity: 'warn', summary: 'Información', detail: 'Correo ingresado no existe' });
          this.isLoad = false;
        }
      })
    }
    else
      this.message.add({ key: 'message', severity: 'error', summary: 'Error', detail: 'Favor ingrese un correo valido' });
  }

}
